module.exports = __webpack_public_path__ + "static/media/saham-logo-ar.1648b326.svg";